// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ruoqN","name":"styles_name__Z24BQ"};